// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { CHECKOUT_STEPS, GOOGLE_EVENTS } from "@sc/XDL/constants";
import { parseProductCategories } from "@sc/XDL/Utilities";

const getDataLayer = () => {
    return (window as any).dataLayer || [];
};

export { getDataLayer };

/* eslint-disable */
(function (window) {
    (window as any)._GaCheckoutFunnel = (
        step: number,
        cart: CartModel,
        currency?: string,
        affiliation?: string,
        // discount?: number,
        includeBrand?: boolean,
        includeCategory?: boolean,
        type?: string,
        fulfillmentMethod?: string,
    ) => {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }
        const googleAnalyticsData = {
            ...(step === CHECKOUT_STEPS.ADDRESS && {
                event: GOOGLE_EVENTS.BEGIN_CHECKOUT,
            }),
            ...(step === CHECKOUT_STEPS.SHIPPING &&
                type === "shipping" && {
                    event: GOOGLE_EVENTS.ADD_SHIPPING_INFO,
                }),
            ...(step === CHECKOUT_STEPS.SHIPPING &&
                type === "payment" && {
                    event: GOOGLE_EVENTS.ADD_PAYMENT_INFO,
                }),
            ecommerce: {
                currency,
                coupon: cart.promotionCode,
                affiliation,
                ...(step === CHECKOUT_STEPS.SHIPPING &&
                    type === "payment" && {
                        payment_type: cart.paymentMethod?.description || "",
                    }),
                ...(step === CHECKOUT_STEPS.SHIPPING &&
                    type === "shipping" && {
                        shipping_tier: fulfillmentMethod ?? (cart.carrier?.description || ""),
                    }),
                items: cart?.cartLines?.map((cartLine, idx) => ({
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    item_brand: includeBrand ? cartLine.brand?.name || "" : undefined,
                    item_list_id: includeCategory ? cartLine.properties?.["categoriesIds"] || "" : undefined,
                    discount: cartLine.pricing
                        ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                            ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                            : 0
                        : 0,
                    coupon: cart.promotionCode,
                    index: idx,
                    ...parseProductCategories(cartLine?.properties?.itemCategoriesShortDescription, true, includeCategory),
                })),
            },
            value: cart.orderSubTotal,
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(googleAnalyticsData);
    };
})(typeof window != "undefined" ? window : {});
/* eslint-enable */
